import React, { useEffect, useState } from "react";
import localforage from "localforage";

const HasPermission = ({ permission, children }) => {
  const [hasPermission, setHasPermission] = useState(false);

  const checkHasPermission = async () => {
    // get the user role permission
    const userPermissions = await localforage.getItem("userPermissions");
    // console.log("------userPermissions-----", userPermissions);
    if (userPermissions) {
      const isPermission = userPermissions.includes(permission);
      setHasPermission(!!isPermission);
    }
  };

  useEffect(() => {
    checkHasPermission();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (typeof children === "function") {
    return <>{children(hasPermission)}</>;
    // return <>{children(true)}</>;
  }
  return hasPermission ? <>{children}</> : "";
};

export default HasPermission;
